@if (request()) {
  <div class="pt-view-request-details__header">
    <h4 class="pt-view-request-details__header-text">
      {{ 'myRequests.viewRequestDetails.header' | translate }}{{ $any(request()).requestId ?? $any(request()).id }}
    </h4>

    <button class="pt-view-request-details__close" type="button" puButton
            size="m" uiType="quaternary" [onlyIcon]="true" (click)="close()">
      <pu-icon iconName="close" size="16" />
    </button>
  </div>

  <form class="pt-view-request-details__body" [formGroup]="form">
    <div class="pt-view-request-details__container">
      <div #leftContainer class="pt-view-request-details__container__left-container">
        <div class="pt-view-request-details__container__left-container__first-row">
          <div class="pt-view-request-details__container__left-container__first-row__first-column">
            <div class="details-item">
              <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.date"></h5>

              <span class="pt-view-request-details__text">
          {{ ($any(request()).date ?? $any(request()).createdAt) | date:'dd MMM y HH:mm' }}
        </span>
            </div>
            @if (request().hasOwnProperty('user')) {
              <div class="details-item">
                <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.sender"></h5>

                <span class="pt-view-request-details__text">
              {{ $any(request()).user.fullName }}
            </span>
              </div>
            }
            @if (request().hasOwnProperty('location')) {
              <div class="details-item">
                <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.location"></h5>
                <span class="pt-view-request-details__text">
                {{ $any(request()).location }}
              </span>
              </div>
            }

          </div>
          <div class="pt-view-request-details__container__left-container__first-row__second-column">
            <div class="details-item">
              @if (isFinAdmin && isAdminMode) {
                <form class="pt-view-request-details__select-category" [formGroup]="categoryForm">
                  <pu-select
                    formControlName="category"
                    [items]="store.categories()"
                    [label]="'myRequests.filters.category' | translate"

                  />
                  @if (showAcceptDeclineCategory()) {
                    <pt-accept-decline-buttons
                      (acceptEmitter)="saveNewCategory()"
                      (declineEmitter)="declineCategoryChange()"
                    />
                  }
                </form>
              } @else {
                <div>
                  <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.category"></h5>

                  <span class="pt-view-request-details__text">
                      {{ $any(request()).category }}
                    </span>
                </div>
              }
            </div>
            @if (request().hasOwnProperty('userTelegramUsername')) {
              <div class="details-item">

                <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.telegram"></h5>

                <span class="pt-view-request-details__text">
              {{ $any(request()).userTelegramUsername }}
            </span>
              </div>
            }

            @if (isAdminMode) {
              @if (isFinAdmin) {
                <form class="pt-view-request-details__select-assignee" [formGroup]="assigneeForm">
                  <pu-select
                    [placeholder]="assigneePlaceholder"
                    formControlName="assignee"
                    [items]="store.assignees()"
                    [label]="'myRequests.filters.assignee' | translate"

                  />
                  @if (showAcceptDeclineAssignee()) {
                    <pt-accept-decline-buttons
                      (acceptEmitter)="saveNewAssignee()"
                      (declineEmitter)="declineAssigneeChange()"
                    />
                  }
                </form>
              } @else {
                <div>
                  <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.assignee"></h5>

                  <span class="pt-view-request-details__text">
                      {{ $any(request()).assignee.fullName }}
                    </span>
                </div>
              }
            }

          </div>
        </div>
        <div class="pt-view-request-details__container__left-container__second-row">
          <div>
            <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.text"></h5>
            @let comments = request().comments;
            @if (comments?.length) {
              <p class="pt-view-request-details__message">
                {{ comments[comments.length - 1].data.message }}
              </p>
            }

          </div>
        </div>
      </div>
      @if (isHeightReceived) {
        <div #rightContainer class="pt-view-request-details__container__right-container">
          @if (isAdminMode) {
            <div class="pt-view-request-details__left pt-view-request-details__outside-buttons">
              @if ($any(request()).userStaffKey) {
                <a
                  class="md:pu-button_m"
                  href="{{ jiraStafProject }}{{ $any(request()).userStaffKey }}"
                  target="_blank"
                  puButton
                  size="l"
                  uiType="secondary"
                >
                  {{ 'myRequests.viewRequestDetails.btn.staff' | translate }}
                </a>
              }
              @if ($any(request()).userSlackId) {
                <a
                  target="_blank"
                  puButton
                  size="m"
                  uiType="secondary"
                  [puSlackLink]="$any(request()).userSlackId"
                >
                  {{ 'myRequests.viewRequestDetails.btn.slack' | translate }}
                </a>
              }
            </div>
          }
          <div
            [ngClass]="!isAdminMode ? 'pt-view-request-details__history-container' : 'pt-view-request-details__admin-history-container'">
            <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.history"></h5>

            <dl class="pt-view-request-details__history">
              @for (item of request().history; track $index) {
                <pu-admin-finance-history-item [item]="item" [categories]="store.categories()" />
              }
            </dl>
          </div>
        </div>
      }

    </div>

    @if (request().comments) {
      @let comments = $any(request()).comments;
      @if (comments[comments.length - 1]?.files.length) {
        <section class="pt-view-request-details__section">
          <div class="pt-view-request-details-attachments">
            <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.attachments"></h5>

            <pu-gallery [images]="galleryImages" />
          </div>
        </section>

        <section class="pt-view-request-details__column-section">
          @for (fileUrl of comments[comments.length - 1].files; track $index) {
            @if (isFileNotImage(fileUrl)) {
              <a class="pu-uploader-file" href="{{ fileUrl }}" target="_blank">
                <pu-icon iconName="info" size="20" />

                <span class="pu-uploader-file__name">
                      {{ getPdfName(fileUrl) }}
                    </span>
              </a>
            }
          }
        </section>
      }

      <div class="pt-view-request-details__divider"></div>

      <section class="pt-view-request-details__section">
        <div class="pt-view-request-details__left">
          <h5 class="pt-view-request-details__title" translate="myRequests.viewRequestDetails.manage"></h5>

          <pu-button-toggle-group
            [value]="selectedStatus()"
            [buttonGroup]="getButtonsBasedOnStatus(request().status)"
            (onValueChange)="updateSelectedStatus($event);" />
        </div>
        <div class="pt-view-request-details__right pt-view-request-details__refresh-button">
          <button type="button" puButton size="l" uiType="quaternary"
                  (click)="refreshRequest($any(request()).requestId ?? $any(request()).id)">
            <pu-icon iconName="refresh" size="20" />
            {{ 'myRequests.viewRequestDetails.btn.refresh' | translate }}
          </button>
        </div>
      </section>

      <section class="pt-view-request-details__controls">
        <pu-text-area class="pt-form-comments" formControlName="comment"
                      [label]="
                              (getCorrectTranslation(isAdminMode ? selectedStatus() : request().status)
                                | translate)
                              + (isCommentRequired(selectedStatus()) ? '*' : '')" />

        <div>
          <pu-uploader
            #uploader
            class="pu-view-request-details__attachment"
            formControlName="attachment"
            [apiS3]="apiS3Url"
            accept=".pdf,.xlsx,.xls,.docx,.doc,.jpg,.jpeg,.png"
            placeholderKey="myRequests.viewRequestDetails.formControl.browseFile"
            hiddenBrowse
            hiddenPlaceholder
            [maxFileSize]="MAX_FILE_SIZE"
          >
            <ng-template #filesTpl>
              @if (uploader.files.length) {
                <div
                  class="pu-uploader-file"
                  (click)="uploader.removeFile($event, 0)"
                >

                  <pu-icon
                    iconName="info"
                    size="20"
                  />

                  <span class="pu-uploader-file__name">
            {{ uploader.files[0].name }}
          </span>

                  <div class="pu-uploader-file__remove">
                    <pu-icon
                      iconName="close"
                      size="16"
                    />
                  </div>
                </div>
              }
            </ng-template>
          </pu-uploader>


          <span class="pt-form-attachment-types">
                  {{ "myRequests.viewRequestDetails.formControl.acceptedTypes" | translate }}</span>
        </div>

      </section>

      <section class="pt-view-request-details__actions">
        <button type="button" puButton size="l" uiType="primary"
                [disabled]="adminConfirmButtonDisabled"
                [translate]="request().status !== selectedStatus() ? 'myRequests.viewRequestDetails.btn.confirm'
                 : 'myRequests.viewRequestDetails.btn.sendComment'"
                (click)="onConfirm($any(request()).id, request().requestIdHash, selectedStatus())">
        </button>

        <button type="button" puButton size="l" uiType="secondary" (click)="resetData()"
                translate="myRequests.viewRequestDetails.btn.cancel">
        </button>
      </section>

      @if (tableData().length) {
        <div class="pu-table-wrapper" [ngClass]="{'with-scroll': tableData().length > 5}">
          <table
            mat-table
            [dataSource]="tableData()"
          >
            <ng-container matColumnDef="date">
              <th
                mat-header-cell
                *matHeaderCellDef
                translate="myRequests.viewRequestDetails.table.date"
              ></th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{
                  element.createdAt + 'Z'
                    | date: 'dd MMM yyyy HH:mm'
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="message">
              <th
                mat-header-cell
                *matHeaderCellDef
                translate="myRequests.viewRequestDetails.table.comment"
              ></th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{ element.message }}
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef
                translate="myRequests.viewRequestDetails.table.status"
              ></th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{ 'dictionary.financialRequestStatuses.' + element.status | translate }}
              </td>
            </ng-container>
            <ng-container matColumnDef="fromUser">
              <th
                mat-header-cell
                *matHeaderCellDef
                translate="myRequests.viewRequestDetails.table.from"
              ></th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                {{ element.fromUser }}
              </td>
            </ng-container>
            <ng-container matColumnDef="file">
              <th
                mat-header-cell
                *matHeaderCellDef
                translate="myRequests.viewRequestDetails.table.file"
              ></th>
              <td
                mat-cell
                *matCellDef="let element"
              >
                @if (element.file) {
                  <a
                    [href]="element.file"
                    target="_blank"
                    rel="noopener"
                    class="btn btn-primary"
                  >
                    <pu-icon
                      iconName="paperclip"
                      size="16"
                    />
                  </a>
                }
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="commentsColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: commentsColumns;"
            ></tr>
          </table>
        </div>
      }
    }

    <section class="pt-view-request-details__actions">
      <div class="footer">
        <button type="button" puButton size="l" uiType="secondary" (click)="close()"
                translate="myRequests.viewRequestDetails.btn.close">
        </button>
      </div>
    </section>

  </form>
}
